import React from "react";

import { Box, FormControl, FormLabel, StyleProps } from "@chakra-ui/react";

import { ListSize, NumericOption } from "@/jenesys-types/list";

import { NumericSelect } from "@/components/forms/BaseForm/selects/NumericSelect";

import { useCrudListContext } from "./CrudListContext";

export interface CrudListSizeSelectProps extends StyleProps {}

const listSizeOptions: Array<NumericOption> = [10, 20, 50].map((value) => ({
  label: `${value}`,
  value
}));

export const CrudListSizeSelect: React.FC<CrudListSizeSelectProps> = ({
  ...styleProps
}) => {
  const { listSize, onListSizeChange } = useCrudListContext();

  return (
    <FormControl
      alignItems="center"
      display="flex"
      flexFlow="row nowrap"
      width="max-content"
      fontSize="sm"
      {...styleProps}
    >
      <FormLabel
        fontSize={14}
        fontWeight="medium"
        marginBottom="none"
        whiteSpace="nowrap"
      >
        Rows per page
      </FormLabel>
      <Box width="85px">
        <NumericSelect
          onChange={onListSizeChange as (newListSize: ListSize | null) => void} // We can safely cast here since we aren't making the <Select> clearable
          options={listSizeOptions}
          value={listSize}
          menuPlacement="top"
        />
      </Box>
    </FormControl>
  );
};
